<template>
  <div class="c-popup" @keydown.esc="$refs.filialsettingspopover.$emit('close')">
    <button :id="`filial-settings-popup-${postCode}-${cellIndex}`" class="c-popup-button">
      <svg width="2" height="13" viewBox="0 0 2 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L1 7M1 11L1 12" stroke="#12C971" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>
    <b-popover
      id="positions-filial-settings-popup"
      ref="filialsettingspopover"
      triggers="click"
      placement="bottomright"
      :target="`filial-settings-popup-${postCode}-${cellIndex}`"
    >
      <svg
        class="c-popup-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <h3 class="c-popup-title">{{ title }}</h3>
      <div :class="{ 'c-popup-list-scrollable': scrollable }" class="c-popup-list">
        <div v-for="item in popupItems" :key="item.name" class="c-popup-list-item">
          <div>{{ item.name }}</div>
          <div class="c-popup-list-item-value">{{ item.value }}</div>
        </div>
      </div>
      <div v-if="scrollable" class="c-popup-list-shadow"></div>
    </b-popover>
  </div>
</template>

<script>
export default {
  name: "c-popup",

  props: ["type", "label", "title", "popupPosition", "popupItems", "scrollable", "postCode", "cellIndex"],

  data() {
    return {
      isShowContainer: false,
    };
  },

  methods: {
    openContainer() {
      this.isShowContainer = true;
    },
    closeContainer() {
      this.isShowContainer = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";

.c-popup {
  &-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    margin: 0;
    border: 0;
    background: transparent;

    & > svg {
      margin-right: 10px;
    }
  }

  &-scrollable {
    padding-right: 21px;
  }

  &-close {
    position: absolute;
    cursor: pointer;
    right: 12px;
    top: 14px;
  }

  &-title {
    text-align: left;
    line-height: 18px;
    font: 500 15px Fira Sans;
  }

  &-list {
    position: relative;
    display: flex;
    flex-direction: column;
    margin-top: 20px;

    &-shadow {
      position: absolute;
      display: block;
      bottom: 29px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
      height: 35px;
      width: 235px;
    }

    &::-webkit-scrollbar {
      width: 4px;
      height: 100%;
      background: white;
      cursor: pointer;
    }

    &::-webkit-scrollbar-thumb {
      background: $color-secondary;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-track {
      background: $color-border-alt;
      width: 4px;
      border-radius: 2px;
    }

    &-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font: 400 13px Fira Sans;
      padding: 10px 0;
      //line-height: 267%;
      //height: 34px;
      border-top: 1px solid $color-border-light;

      &-value {
        max-width: 120px;
      }

      &:last-child {
        border-bottom: 1px solid $color-border-light;
      }
    }
  }

  &-list-scrollable {
    max-height: 244px;
    overflow: auto;
    padding-right: 10px;
  }
}
</style>
